import * as processUI from '../modules/process/ui-definition/process-ui'
import * as customerUI from '../modules/customer/ui-definition/customer-ui'
import * as salesOrderUI from '../modules/sales-order/ui-definition/sales-order-ui'

export const WIDGET_LIST = {
    [processUI.OVERVIEW]: 'Task Overview',
    [processUI.COMMENT_LIST]: 'Comment Section',
    [processUI.CREATE_IPR_APPOINTMENT]: 'Create IPR Appointment',
    [processUI.CREATE_3DSCAN_APPOINTMENT]: 'Create 3D-Scan Appointment',
    [processUI.STATE_TRANSITION_LOG_CONTAINER]: 'State History',
    [processUI.TECHNICAL_LOG_CONTAINER]: 'Technical Log',
    [processUI.SALES_ORDER_OVERVIEW_WIDGET]: 'Overview',
    [processUI.SALES_ORDER_CUSTOMER_WIDGET]: 'Sales Order Customer',
    [processUI.SENT_EMAIL_WIDGET]: 'Emails',
    [processUI.WHATSAPP_MESSAGES_WIDGET]: 'Whatsapp Messages',
    [processUI.CUSTOMS_INVOICE_LIST_WIDGET]: 'Customs Invoices',
    [processUI.MOVEMENT_CERTIFICATE_NUMBER_WIDGET]: 'Movement Certificate Number',
    [processUI.INVOICE_LIST_WIDGET]: 'Invoices',
    [processUI.PAYMENT_LIST_WIDGET]: 'Payments',
    [processUI.TRAY_SIZE_WIDGET]: 'Tray size',
    [processUI.IMPRINT_SCAN_STATUS_WIDGET]: 'Imprint and Scan Status',
    [processUI.PHYSICIAN_AND_SUPPLIER_WIDGET]: 'Physician and Supplier',
    [processUI.TREATMENT_EXECUTION_WIDGET_CONTAINER]: 'Treatment Execution',
    [processUI.TREATMENT_FEEDBACK_WIDGET]: 'Treatment Feedback',
    [processUI.CUSTOMER_IMAGE_WIDGET]: 'Patient Photos',
    [processUI.CUSTOMER_IMAGE_UPLOAD_WIDGET]: 'Upload Photos',
    [processUI.CUSTOMER_CONTACT_WIDGET]: 'Address',
    [processUI.TREATMENT_PLAN_WIDGET]: 'Treatment Plan',
    [processUI.SCAN_FILE_UPLOAD_WIDGET]: 'Scan File Upload',
    [processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET]: 'Treatment Plan File Upload',
    [processUI.IPR_INSTRUCTIONS_WIDGET]: 'IPR Instructions',
    [processUI.PATIENT_IPR_WISHES_WIDGET]: 'Patient IPR Wishes',
    [processUI.TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET]: 'Treatment File Plan Upload (external)',
    [processUI.PRODUCTION_FILE_UPLOAD_WIDGET]: 'Production File Upload',
    [processUI.TREATMENT_QUOTATION_WIDGET]: 'Treatment Quotation',
    [processUI.REFUND_SEPA_TRANSFER_WIDGET]: 'Refund with Sepa Transfer File',
    [processUI.ALIGNER_LABEL_WIDGET_CONTAINER]: 'Aligner Label',
    [processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER]: 'Cannot be treated reason',
    [processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER]: 'Pre Treatment / Cannot be treated reason',
    [processUI.WHATS_APP_TEXT_WIDGET_CONTAINER]: 'WhatsApp Text',
    [processUI.TREATMENT_DURATION_WIDGET_CONTAINER]: 'Number of aligners',
    [processUI.TREATMENT_CLASSIFICATION_WIDGET_CONTAINER]: 'Medical/Non Medical Treatment Classification',
    [processUI.TREATMENT_VISUALIZATION_WIDGET_CONTAINER]: 'Treatment Vizualization',
    [processUI.SHIPMENT_LIST_WIDGET_CONTAINER]: 'Shipment',
    [processUI.INITIAL_HESITATION_WIDGET_CONTAINER]: 'Initial Hesitation',
    [processUI.TRANSITION_LIST_WIDGET_CONTAINER]: 'Transition List',
    [processUI.TREATMENT_PAYMENT_WIDGET]: 'Treatment Payments',
    [processUI.DELIVERY_TRACKING_WIDGET]: 'Shipping Tracking Number',
    [processUI.SUPPLIER_TRACKING_NUMBER_WIDGET]: 'Supplier Tracking Number',
    [processUI.PHOTO_CHECKIN_WIDGET]: 'Photo Checkin Result',
    [processUI.MEDICAL_PHOTO_CHECK_WIDGET]: 'Medical Photo Check',
    [processUI.INVOICE_CORRECTION_WIDGET]: 'Invoice Correction',
    [processUI.PRODUCTION_CASE_CARD_WIDGET]: 'Production Case Card',
    [processUI.MODEL_SELECTION_WIDGET]: 'Model Selection',
    [processUI.MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER]: 'Match 3Shape',
    [processUI.PATIENT_SCANNED_WIDGET]: 'Patient Scanned',
    [processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER]: 'Anamnesis Edit',
    [processUI.ANAMNESIS_LIST_WIDGET_CONTAINER]: 'Anamnesis List',
    [processUI.APPOINTMENT_LIST_WIDGET_CONTAINER]: 'Appointment List',
    [processUI.PROCESS_OVERVIEW]: 'Process Overview',
    [processUI.PROCESS_TASK_LIST]: 'Worklist',
    [processUI.VOUCHER_WIDGET_CONTAINER]: 'Voucher Info',
    [processUI.COMPLEXITY_TREATMENT_WIDGET]: 'Treatment Plan Complexity',
    [salesOrderUI.SALES_ORDER_OVERVIEW]: 'Sales Order Overview',
    [salesOrderUI.SALES_ORDER_STATUS_HISTORY]: 'Status History',
    [customerUI.CUSTOMER_PROCESS_INSTANCE_LIST]: 'Process',
    [customerUI.CUSTOMER_SALES_ORDER_LIST]: 'Sales Order',
    [customerUI.CUSTOMER_XRAY_FILE_UPLOAD]: 'X-Ray Upload (external)',
    [processUI.CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET]: 'Drive Files',
    [processUI.CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET]: 'Photo precheck',
    [processUI.CBCT_FILE_UPLOAD_WIDGET]: 'CBCT Upload',
    [processUI.IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET]: 'Implant Treatment Plan',
    [processUI.IMPLANT_TREATMENT_QUOTATION_WIDGET]: 'Implant Treatment Quotation',
    [processUI.REFINEMENT_REASON_WIDGET]: 'Refinement Reason',
    [processUI.LOW_NPS_REASON_WIDGET_CONTAINER]: 'Low NPS reason',
    [processUI.PARTIAL_INVOICE_CORRECTION_CONTAINER]: 'Partial Invoice Correction',
    [customerUI.CUSTOMER_COMMENT_LIST]: 'View comments (Customer)',
    [customerUI.CUSTOMER_ADD_COMMENT]: 'Add comments (Customer)',
    [processUI.REQUEST_MEDICAL_EVALUATION]: 'Request Medical Eval',
    [processUI.PROCESS_LIST]: 'Process',
    [processUI.SALES_NOTE_WIDGET_CONTAINER]: 'Sales Note',
    [processUI.ATTACHMENT_NEEDED_WIDGET]: 'Attachment Needed',
    [processUI.ATTACHMENT_AGREEMENT_WIDGET]: 'Attachment Agreement',
}



// WEBPACK FOOTER //
// ./src/constant/widgets.js